
export const siteUrl = 'https://tgenz.com'

export const siteName = 'Tigenz blog'

export const sanityProjectId = '3f534m2o'

export const sanityProjectDataset = process.env.GATSBY_SANITY_DATASET || 'production'
